/**
 * Search terms matching this pattern will be searched using match_phrase.
 * @see https://www.elastic.co/guide/en/elasticsearch/reference/7.1/query-dsl-match-query-phrase.html
 */
export const PHRASE_QUERY_PATTERNS = {
    // As part of story OR-22 - the order reference format was changed to a new format.
    LegacyOrderReferenceMatcher: new RegExp(/[A-Z]{2}-(OR|JO)-\d{4}-\d{4}/i),
};
/**
 * This matches the order reference format where a string begins with
 * a specified court system code and is followed by a number.
 * e.g COURT1, al982, ElToN925, beN10
 */
export const COURT_SYSTEM_ORDER_REFERENCE_MATCHER = (courtSystemCode) => {
    return new RegExp(`^${courtSystemCode}\\d+$`, 'i');
};
